import { Assets } from "@/utils/assets";
import { Global } from "@/utils/global";

export class AmmunitionGroup extends Phaser.Physics.Arcade.Group{

    private shootsfx: any;

    constructor(scene: Phaser.Scene){
        super(scene.physics.world, scene);
        /*
        this.shootsfx = scene.sound.add('shoot',{
            volume: 0.5, loop: false
        });
        */
        this.createMultiple({
            classType: Ammunition,
            frameQuantity: 1,
            active: false,
            visible: false,
            repeat: 1,
            key: 'ammunition'
        });
    }

    public shoot(x: number, y: number): void{
        const ammunition = this.getFirstDead(false);
		if (ammunition) {
            //this.shootsfx.play();
			ammunition.fire(x, y);
		}
    }

}

class Ammunition extends Phaser.Physics.Arcade.Sprite{

    constructor(scene: Phaser.Scene, x: number, y: number) {
		super(scene, x, y, Assets.GAME.ID, 'ammunition.png');
	}

    public fire(x:number, y:number): void{
        this.body.reset(x, y);
        this.setScale(0.5);
		this.setActive(true);
		this.setVisible(true);
		this.setVelocityX(Math.floor(Global.SCREEN_W * 1));
    }

    preUpdate(time: number, delta: any) {
		super.preUpdate(time, delta);
		if (this.x >= Global.SCREEN_W * 1.01) {
			this.setActive(false);
			this.setVisible(false);
		}
	}
    
}